import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import { PopoverManagerImpl } from './impls/popover-manager';
import { PopoverRegistryImpl } from './impls/popover-registry';
import { PopoverManager } from './popover-manager';
import { PopoverRegistry } from './popover-registry';

export const popoverModule = new ContainerModule(bind => {
    bind<PopoverRegistry>(PopoverRegistry).to(PopoverRegistryImpl);
    bind<PopoverManager>(PopoverManager).to(PopoverManagerImpl);
});
